import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { TransactionDocuments } from '../../../../models/TransactionDocuments/transaction-documents.model';

export interface RenameCommonDocumentTypeRequest {
    engagementId: number;
    name: string;
    newName: string;
}

export const RenameCommonDocumentType = createAsyncThunk(
    'transactionDocuments/renameCommonDocumentType',
    async (params: RenameCommonDocumentTypeRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/Marketplace/Engagements/${params.engagementId}/TransactionDocuments/CommonDocumentTypes`,
                { name: params.name, newName: params.newName }
            );

            if (response.status !== 200) {
                throw new Error('Failed to rename the common document type');
            }

            return response.data as TransactionDocuments;
        } catch (error) {
            createNotification('Could not rename the common document type.', 'error');
            throw error;
        }
    }
);
